export default __webpack_public_path__ + "static/media/KN.bed4d32f.svg";